import { render } from "./initiate_lab_modal.vue?vue&type=template&id=68b86b6a&scoped=true"
import script from "./initiate_lab_modal.vue?vue&type=script&lang=js"
export * from "./initiate_lab_modal.vue?vue&type=script&lang=js"

import "./initiate_lab_modal.vue?vue&type=style&index=0&id=68b86b6a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b86b6a"]])

export default __exports__